/**
 * Hook to get current user's EMPLID from AWS Cognito session
 * Follows the existing pattern from util/login.js
 * In admin mode, returns the selected student's emplid instead
 */

import React, { useState, useEffect, useContext } from 'react';
import { fetchCurrentSession } from '../../util/login';
// AdminEmplIdOverrideContext - shared context for admin override functionality

// Create the AdminEmplIdOverrideContext for admin functionality
export const AdminEmplIdOverrideContext = React.createContext(null);

export const useUserEmplid = () => {
  // Check for admin override first
  const adminOverride = useContext(AdminEmplIdOverrideContext);

  const [userInfo, setUserInfo] = useState({
    emplid: null,
    isAuthenticated: false,
    isLoading: true
  });

  useEffect(() => {
    // If we have an admin override, use that instead of fetching session
    if (adminOverride?.emplid) {
      setUserInfo({
        emplid: adminOverride.emplid,
        isAuthenticated: true,
        isLoading: false,
        isAdminOverride: true
      });
      return;
    }

    const getUserInfo = async () => {
      try {
        const session = await fetchCurrentSession();

        if (session) {
          // Extract EMPLID from JWT token payload
          // Common locations in Cognito tokens:
          const emplid = session.emplid ||
            session['custom:emplid'] ||
            session['custom:employeeId'] ||
            session.sub;

          setUserInfo({
            emplid,
            isAuthenticated: true,
            isLoading: false
          });
        } else {
          setUserInfo({
            emplid: null,
            isAuthenticated: false,
            isLoading: false
          });
        }
      } catch (error) {
        console.error('Error fetching user session:', error);
        setUserInfo({
          emplid: null,
          isAuthenticated: false,
          isLoading: false
        });
      }
    };

    getUserInfo();
  }, [adminOverride]);

  return userInfo;
};

export default useUserEmplid;